module.exports = __webpack_public_path__ + "be9e50a6b48e2a2c65f5126978970bfd.mp3";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/geweldig_1.mp3
// module id = 64
// module chunks = 0